import React, { useEffect, useState } from 'react';
import { Box, Container, Divider, makeStyles } from '@material-ui/core';
import { useMaintenancePackage } from 'src/hooks/useMaintenancePackage';
import { useTranslation } from 'react-i18next';
import useAuth from 'src/hooks/useAuth';
import Page from 'src/components/Page';
import useStore from 'src/hooks/useStore';
import { Header } from 'src/components/Headers';
import { MaintenancePackage } from 'src/constants/modules/maintenancePackage';
import { MAINTENANCE_PACKAGE_AUTH } from 'src/constants/permissions';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';
import { useParams } from 'react-router-dom';
import { MaintenancePackageForm } from 'src/components/MaintenancePackages/Forms/components';
import { MAINTENANCE_PACKAGE_DETAILS_POPULATE } from '../MaintenancePackageDetailsView/constants';
import { TMaintenancePackageFormikValues } from 'src/components/MaintenancePackages/Forms/components/types';
import { getDocumentIdsFromArray } from 'src/utils/mongo/getDocumentIdsFromArray';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const UpdateMaintenancePackage = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { user } = useAuth();
    const {
        maintenancePackage,
        updateMaintenancePackageById,
        getMaintenancePackageById,
    } = useMaintenancePackage();
    const { getStores } = useStore();
    const [values, setValues] = useState<TMaintenancePackageFormikValues>();
    const { maintenancePackageId } = useParams<{
        maintenancePackageId: string;
    }>();
    const history = useHistory();

    useEffect(() => {
        if (user._id) getStores();
    }, [user]);

    useEffect(() => {
        if (maintenancePackageId)
            getMaintenancePackageById(maintenancePackageId);
    }, [maintenancePackageId]);

    useEffect(() => {
        if (maintenancePackage)
            setValues({
                name: maintenancePackage.name,
                details: maintenancePackage.details,
                stores: getDocumentIdsFromArray(maintenancePackage.stores),
            });
    }, [maintenancePackage]);

    const handleSubmit = async (values: Partial<IMaintenancePackage>) => {
        updateMaintenancePackageById(maintenancePackageId, values, {
            populate: MAINTENANCE_PACKAGE_DETAILS_POPULATE,
        });
        history.push(
            `/management/maintenance-packages/${maintenancePackageId}`
        );
    };

    return (
        <Page className={classes.root} title={t('maintenancePackage.Update')}>
            <Container maxWidth="lg">
                <Header
                    module={MaintenancePackage.name}
                    route={MaintenancePackage.route}
                    crud={{
                        goBack: true,
                    }}
                    permission={MAINTENANCE_PACKAGE_AUTH}
                />
                <Divider />
                <Box mt={3}>
                    <MaintenancePackageForm
                        mode="edit"
                        onSubmit={handleSubmit}
                        initialValues={values}
                    />
                </Box>
            </Container>
        </Page>
    );
};
